import { toNum } from '@/utils/string'
import { fixedNumberCopy } from '@/utils/number'

// Рассчитываем свободный остаток по формуле (weight - (reserved + reservedStart))
export function calcFreeAmount (item) {
  // Проверяем, что все нужные поля есть и это числа
  const weight = toNum(item.weight) || 0
  const reserved = toNum(item.weight_reserved) || 0
  const reservedStart = toNum(item.weight_reserved_start) || 0

  const freeBalance = (weight - (reserved + reservedStart))
  return fixedNumberCopy(freeBalance, 3)
}
